const StatusMap = {
    PENDING_APPROVAL: { status: 'PENDING_APPROVAL', message: 'Ready to Create', color: '#CB8939' },
    FAILED:  { status: 'FAILED', message: 'Failed', color: '#F0235B' },
    PROCESSING: { status: 'PROCESSING', message: 'Creating Zones', color: '#9F2E95' } ,
    APPROVED: { status: 'APPROVED', message: 'Creating Zones', color: '#9F2E95' },
    COMPLETED:  { status: 'COMPLETED', message: 'Completed', color: 'green' },
    DELETED:  { status: 'DELETED' } 
}

module.exports = {
    StatusMap
}